import HTTP_METHODS from "src/general/constants/http/httpMethods";
import { createBaseQueryDefinition } from "src/business.InterfaceLayer/store/services/utils.service/ResponseTransforms";
import MAIN_PATHS from "src/business.InterfaceLayer/store/mainPaths";
import { ApiQueryBuilder } from "src/business.InterfaceLayer/store/types/ApiQueryBuilder.type";
import { Nullable } from "../../../../../types/Nullable.type";
import {
	RegionGetRequest as Req,
	RegionGetResponse as Res,
} from "src/business.InterfaceLayer/store/entities/region.entity/redux/api/types/GET";
import { RegionFromDtoGet as Dto } from "../../../services/dto/from.dto";

const getRequestBaseDefinition = createBaseQueryDefinition(
	HTTP_METHODS.GET,
	MAIN_PATHS.REGION
);

const regionApiGetQueries = (build: ApiQueryBuilder) => ({
	getRegions: build.query<Nullable<Res.RegionGetRegions>, Req.RegionGetRegions>(
		{
			query: (params) => ({
				...getRequestBaseDefinition({ path: "", params }),
			}),
			transformResponse: Dto.regionsFromDto,
			providesTags: [`${MAIN_PATHS.REGION}TAG`],
		}
	),
});

export default regionApiGetQueries;
